/**
 * @param {Array<{name: string}>|null|undefined} mappingFields
 * @returns {Set<string>}
 */
export const buildMappedPriceLevelFieldKeys = (mappingFields) =>
    new Set(
        (mappingFields ?? [])
            .map((field) => field.name)
            .filter((name) => typeof name === 'string' && name.startsWith('priceLevel_')),
    );
